const colors = {
  primary: "#0fb960",
  primaryDark: "#00a750",
  primaryLight: "#00e66e",
  primaryNeon: "#05fc7b",
  background: "#030409",
  overlayBlack: "rgba(0, 0, 0, 0.87)",
  scrollTrack: "rgba(216, 216, 216, 0.35)",
  green: {
    100: "#00e66e",
    200: "#00e66e",
    300: "#00e66e",
    400: "#0fb960",
    500: "#0fb960",
    600: "#1c7c4d",
    800: "#0c4029",
    900: "#0c4029",
  },
  gray: {
    100: "#f9f9f9",
    200: "#e9e9eb",
    300: "#d2d3d9",
    400: "#7c8391",
    600: "#393c41",
    800: "#272D33",
    900: "#1e2126",
  },
  black: {
    700: "#101316",
    800: "#0c1014",
    900: "#030409",
  },
  yellow: {
    100: "#f8c12c",
    200: "#f8c12c",
    300: "#f8c12c",
    400: "#f8c12c",
    500: "#f8c12c",
    600: "#f8c12c",
    800: "#ad6603",
    900: "#ad6603",
  },
  amber: "#f2a72d",
  overlayDark: "rgba(0, 0, 0, 0.4)",
  overlayLight: "rgba(255, 255, 255, 0.9)",
};

export default colors;
